<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      menuList: [],
      _beforeUnload_time: "",
      _gap_time: "",
    };
  },
  mounted() {
    window.addEventListener("beforeunload", (e) => {
      if (e.origin && e.origin !== "http://example.org")
        // Compliant
        return;
      this.beforeunloadHandler(e);
    });
    window.addEventListener("unload", (e) => {
      if (e.origin && e.origin !== "http://example.org")
        // Compliant
        return;
      this.unloadHandler(e);
    });
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) =>
   
      this.beforeunloadHandler(e)
    );
    window.removeEventListener("unload", (e) => this.unloadHandler(e));
  },
  methods: {
    beforeunloadHandler(e) {
      this._beforeUnload_time = new Date().getTime();
    },
    unloadHandler(e) {
      this._gap_time = new Date().getTime() - this._beforeUnload_time;
      //判断是窗口关闭还是刷新
      if (this._gap_time <= 5) {
        //如果是登录状态，关闭窗口前，移除用户
        if (localStorage.getItem("auth")) {
          window.localStorage.removeItem("userId");
          window.localStorage.removeItem("userName");
          window.localStorage.removeItem("auth");
          window.localStorage.removeItem("TokenExpire");
          window.localStorage.removeItem("refreshtime");
          window.localStorage.removeItem("expires_in");
          window.localStorage.removeItem("menuData");
          window.localStorage.removeItem("LocalIp");
          window.localStorage.removeItem("language");
          sessionStorage.removeItem("Authorization");
          sessionStorage.removeItem("areaListForUser");
          sessionStorage.removeItem("area");
          sessionStorage.removeItem("deviceList");
          delCookie("auth");

          delCookie("LocalIp");
        }
      }
    },
  },
};
</script>

<style>
@import "assets/css/base.css";
</style>
